import React from 'react'


const Loading = () => {
  return (
    <div className={ 'loader-position' }>
      <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
    </div>
  )
}

export default Loading
